import React from "react";
import ConfirmActionModal from "./ConfirmActionModal";

interface TransposeConfirmModalProps {
  visible: boolean;
  onCancel: () => void;
  onOk: () => Promise<void>;
  confirmText: string;
  setConfirmText: (text: string) => void;
  requiredConfirmText: string;
  transposing: boolean;
}

const TransposeConfirmModal: React.FC<TransposeConfirmModalProps> = ({
  transposing,
  ...props
}) => {
  const warningItems = [
    "更改为全功能项目后，将无法再改回仅摘要项目",
    "全功能项目需 Pro 及以上会员",
    "更改后，项目将使用会员的有效期",
  ];

  return (
    <ConfirmActionModal
      {...props}
      title="更改计费方式确认"
      okText="确认更改"
      warningItems={warningItems}
      loading={transposing}
      icon={
        <i
          className="ri-exchange-line"
          style={{ fontSize: 22, color: "#faad14", marginRight: 12 }}
        />
      }
    />
  );
};

export default TransposeConfirmModal;
